import {Link, useLocation} from "react-router-dom";
import React, {useEffect, useMemo, useState} from "react";
import {EditLocalStoragePagesData} from "../../../utils/EditLocalStoragePagesData";
import Box from "@mui/material/Box";
import {Button, Checkbox, Typography} from "@mui/material";
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from "material-react-table";
import MenuItem from "@mui/material/MenuItem";
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import NameModal from "../../../components/UI/modal/NameModal";
import CompositionController from "../../../API/organization/CompositionController";
import ButtonCreate from "../../../components/UI/button/ButtonCreate";
import {typeCompositionModule} from "../../../data/TypeCompositionModule";
import {cornerTypeModule} from "../../../data/CornerTypeModule";
import ModalModule from "../../../components/UI/modal/ModalModule";
import ModalComposition from "../../../components/UI/modal/ModalComposition";
import {SideBaseModule} from "../../../data/SideBaseModule";
import {HeightLocationModule} from "../../../data/HeightLocationModule";
import ModuleController from "../../../API/organization/ModuleController";
import {replaceEmptyStringsOnNull} from "../../../utils/ReplaceEmptyStringsOnNull";
import {calcFilterData} from "../../../utils/common/calcFilterData";
import {OrderTableFilterData} from "../../../data/FilterTables/OrderTableFilterData";
import {CompositionTableFilterData} from "../../../data/FilterTables/CompositionTableFilterData";
import CheckIcon from "@mui/icons-material/Check";
import {ButtonGroupTabBar} from "../../../components/UI/button/ButtonGroupTabBar";
import UploadFilesRequestsForm from "../../organization/orders/estimate/UploadFilesRequestsForm";

const compositionImports = [
    {
        id: 1,
        helpText: "Импорт композиций из файла",
        upload: CompositionController.upload,
    },
    {
        id: 2,
        helpText: "Импорт модуля в композиции",
        upload: CompositionController.uploadModules,
    },
    {
        id: 3,
        helpText: "Создание зависимостей через файл",
        upload: CompositionController.uploadModulesDepend,
    },
    {
        id: 4,
        helpText: "Добавление модулей в зависимости",
        upload: CompositionController.uploadModulesDependModules,
    },
]

const Composition = ({itemId, handleModalAlert}) => {
    const cornerTypeModuleList = Object.entries(cornerTypeModule)
    const typeCompositionModuleList = Object.entries(typeCompositionModule)
    const initValue = {
        "name": "",
        "shortDescription": "",
        "cornerType": cornerTypeModuleList[0][0],
        "typeComposition": typeCompositionModuleList[0][0],
        "price": null,
        "alternativePrice": null,
        "discountAmount": null,
        "top": false,
        "discount": false,
        "typeBodyTop": null,
        "nameShortBodyTop": null,
        "typeBodyBottom": null,
        "nameShortBodyBottom": null,
        "typeFrontTop": null,
        "nameShortFrontTop": null,
        "typeFrontBottom": null,
        "nameShortFrontBottom": null,
        "typeTableTop": null,
        "nameShortTableTop": null,
        "countertopCuttingTreatment": null,
        "typeWallPanel": null,
        "nameShortWallPanel": null,
        "collection": null,
        "colorScheme": null
    }
    const pathname = useLocation().pathname
    const [data, setData] = useState([]);
    const [modal, setModal] = useState(false);
    const [currentEditRowData, setCurrentEditRowData] = useState(initValue);
    const [filteredData, setFilteredData] = useState(data)
    const [globalFilter, setGlobalFilter] = useState('');
    const [columnsFilter, setColumnsFilter] = useState([]);
    const [showColumnFilters, setShowColumnFilters] = useState(false)
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })
    const [loading, setLoading] = useState(false)
    const [tab, setTab] = useState(1)
    const [change, setChange] = useState(false)
    const handleShowColumnFilters = () => {
        setShowColumnFilters(!showColumnFilters)
        if (showColumnFilters) {
            handleSearchQuery([], data, null, true)
        }
    }
    useEffect(() => {
        const {searchQuery, pageSize, savedTab} = getStartPageSize()
        if (savedTab) {
            setTab(savedTab)
        }
        CompositionController.get().then(function (response) {
            setData(response.data);
            handleSearchQuery(searchQuery, response.data, pageSize)
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, [change]);

    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData(`${pathname}+${itemId}`, "pageSize", nextState.pageSize)
        }
    }
    const handleSearchQuery = (searchQuery, prevData, pageSize, isColumnFilters) => {
        const newColumnsFilter = isColumnFilters ? searchQuery : columnsFilter
        const newGlobalFilter = isColumnFilters ? globalFilter : searchQuery || ""

        const data = [...prevData]
        const globalFilterData = newGlobalFilter ? calcFilterData(data, newGlobalFilter, CompositionTableFilterData) : data
        const newData = newColumnsFilter.reduce((accumulator, currentValue) => {
            return calcFilterData(accumulator, currentValue?.value, [CompositionTableFilterData.find(el => el.idFromColumnFilter === currentValue.id)])
        }, globalFilterData);

        setFilteredData(newData)

        tableOptionsHandle({
            ...tableOptions,
            totalElements: newData.length,
            pageSize: pageSize ? pageSize : tableOptions?.pageSize
        })

        if (isColumnFilters) {
            setColumnsFilter(searchQuery)
        } else {
            setGlobalFilter(searchQuery || "")
            if (searchQuery !== globalFilter) {
                EditLocalStoragePagesData(`organization/orders`, "searchQuery", searchQuery)
            }
        }
    }
    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const pageSize = pagesData[`${pathname}+${itemId}`]?.pageSize
        const searchQuery = pagesData[`${pathname}+${itemId}`]?.searchQuery
        const savedTab = pagesData[`${pathname}+${itemId}`]?.tab

        return {searchQuery, pageSize, savedTab}
    }

    const handleChangeTab = (nextTab) => {
        setTab(nextTab)
        EditLocalStoragePagesData(`${pathname}+${itemId}`, "tab", nextTab)
    }

    const handleClose = () => {
        setModal(false)
        setCurrentEditRowData(initValue)
    }

    const handleUpdate = (value, submit) => {
        setLoading(true)
        const {
            lengthLeft,
            lengthLeftTableTop,
            lengthLeftTop,
            lengthRight,
            lengthRightTableTop,
            lengthRightTop,
            ...rest
        } = value
        CompositionController.edit(replaceEmptyStringsOnNull(rest), rest.id)
            .then(function (response) {
                const newData = data.map(el => el.id === response.data.id ? response.data : el)
                setData(newData)
                handleSearchQuery(globalFilter, newData)
                submit()
                handleModalAlert("Данные изменены", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error)
            })
            .finally(() => setLoading(false))
    }

    const handleSubmit = (value, submit) => {
        setLoading(true)
        CompositionController.save(replaceEmptyStringsOnNull(value))
            .then(function (response) {
                const newData = [...data, response.data]
                setData(newData)
                handleSearchQuery(globalFilter, newData)
                submit()
                handleModalAlert("Данные добавлены", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error)
            })
            .finally(() => setLoading(false))
    }

    const handleAdd = () => {
        setModal(true)
    }
    const handleEdit = (row) => {
        setCurrentEditRowData(row);
        setModal(true)
    };

    const columns = useMemo(() => {
        const baseColumns = [
            {
                header: 'Наименование', accessorKey: 'name', minSize: 200,
                Cell: ({cell, row}) => (
                    <li key={cell.getValue()}>
                        <Link
                            to={'/organization/composition/' + row.original.id}>{row.original.name}</Link>
                    </li>
                ),
            },
            {
                header: 'Описание', accessorKey: 'shortDescription', minSize: 200,
            },
            {
                header: 'Тип композиции', accessorKey: 'typeComposition', minSize: 15, maxSize: 15,
                Cell: ({cell}) => typeCompositionModule[cell.getValue()],
            }, {
                header: 'Тип кухни по расположению', accessorKey: 'cornerType', minSize: 15, maxSize: 15,
                Cell: ({cell}) => cornerTypeModule[cell.getValue()],
            },
            {
                header: 'Длина слева', accessorKey: 'lengthLeft', minSize: 15, maxSize: 15,
            },
            {
                header: 'Длина справа', accessorKey: 'lengthRight', minSize: 15, maxSize: 15,
            },
            {
                header: 'Длина слева сверху', accessorKey: 'lengthLeftTop', minSize: 15, maxSize: 15,
            },
            {
                header: 'Длина справа сверху', accessorKey: 'lengthRightTop', minSize: 15, maxSize: 15,
            },
            {
                header: 'Длина слева по столешнице', accessorKey: 'lengthLeftTableTop', minSize: 200,
            },

            {
                header: 'Длина справа по столешнице', accessorKey: 'lengthRightTableTop', minSize: 200,
            },
            {
                header: 'Цена', accessorKey: 'price', minSize: 15, maxSize: 15,
            },
            {
                header: 'Материал верха корпуса', accessorKey: 'nameBodyTop', minSize: 200,
            },
            {
                header: 'Тип верха корпуса', accessorKey: 'typeBodyTop', minSize: 15, maxSize: 15,
            },
            {
                header: 'Наименование верха корпуса', accessorKey: 'nameShortBodyTop', minSize: 15, maxSize: 15,
            },

            {
                header: 'Материал низа корпуса', accessorKey: 'nameBodyBottom', minSize: 200,
            },
            {
                header: 'Тип низа корпуса', accessorKey: 'typeBodyBottom', minSize: 15, maxSize: 15,
            },
            {
                header: 'Наименование низа корпуса', accessorKey: 'nameShortBodyBottom', minSize: 15, maxSize: 15,
            },

            {
                header: 'Материал верха фасада', accessorKey: 'nameFrontTop', minSize: 200,
            },
            {
                header: 'Тип верха фасада', accessorKey: 'typeFrontTop', minSize: 15, maxSize: 15,
            },
            {
                header: 'Наименование верха фасада', accessorKey: 'nameShortFrontTop', minSize: 15, maxSize: 15,
            },

            {
                header: 'Материал низа фасада', accessorKey: 'nameFrontBottom', minSize: 200,
            },
            {
                header: 'Тип низа фасада', accessorKey: 'typeFrontBottom', minSize: 15, maxSize: 15,
            },
            {
                header: 'Наименование низа фасада', accessorKey: 'nameShortFrontBottom', minSize: 15, maxSize: 15,
            },
            {
                header: 'Материал верха столешницы', accessorKey: 'nameTableTop', minSize: 200,
            },
            {
                header: 'Тип верха столешницы', accessorKey: 'typeTableTop', minSize: 15, maxSize: 15,
            },
            {
                header: 'Наименование верха столешницы', accessorKey: 'nameShortTableTop', minSize: 220,
            },
            {
                header: 'Обработка среза столешницы', accessorKey: 'countertopCuttingTreatment', minSize: 200,
            },
            {
                header: 'Материал стеновой панели', accessorKey: 'nameWallPanel',minSize: 200,
            },
            {
                header: 'Тип стеновой панели', accessorKey: 'typeWallPanel', minSize: 15, maxSize: 15,
            },
            {
                header: 'Наименование стеновой панели', accessorKey: 'nameShortWallPanel', minSize: 200,
            },
            {
                header: 'Коллекция', accessorKey: 'collection', minSize: 15, maxSize: 15,
            },
            {
                header: 'Название расцветки', accessorKey: 'colorScheme', minSize: 15, maxSize: 15,
            },
            {
                header: 'Цена в альтернативной валюте', accessorKey: 'alternativePrice', minSize: 250,
            },
            {
                header: 'Популярное', accessorKey: 'top', size: 8,
                grow: false,
                Cell: ({cell, row}) => <Checkbox
                    cell={cell}
                    checked={row.original.top}
                    disabled={true}
                    sx={{padding: "7px", '& .MuiSvgIcon-root': {fontSize: 22}}}
                >
                </Checkbox>,
            },
            {
                header: 'Скидка', accessorKey: 'discount', size: 8,
                grow: false,
                Cell: ({cell, row}) => <Checkbox
                    cell={cell}
                    checked={row.original.discount}
                    disabled={true}
                    sx={{padding: "7px", '& .MuiSvgIcon-root': {fontSize: 22}}}
                >
                </Checkbox>,
            },
            {
                header: 'Сумма скидки', accessorKey: 'discountAmount', minSize: 15, maxSize: 15,
            },
        ]

        return baseColumns;

    }, [data, filteredData]);


    const menuItem = [
        {type: "edit", text: "Редактировать", handler: handleEdit},
    ]

    return (<div>
        <Box
            sx={{display: 'flex', justifyContent: "space-between", paddingBottom: "30px"}}
        >
            <Typography sx={{fontSize: "24px", fontWeight: 700}}>Композиции</Typography>
            {tab === 1 && <ButtonCreate
                text={"Добавить"}
                width={130}
                onClick={handleAdd}
            />}
        </Box>
        <ButtonGroupTabBar activeTab={tab}>
            <Button tabIndex={1} onClick={() => handleChangeTab(1)}>
                <CheckIcon/>
                Композиции
            </Button>
            <Button tabIndex={2} onClick={() => handleChangeTab(2)}>
                <CheckIcon/>
                Импорт
            </Button>
        </ButtonGroupTabBar>
        {tab === 2 ? (
            <Box sx={{paddingTop: "30px", display: "flex", flexDirection: "column", gap: "10px"}}>
                {compositionImports.map((item) => (
                    <UploadFilesRequestsForm
                        key={item.id}
                        uploadData={item}
                        change={change}
                        setChange={setChange}
                        multiple={false}
                        handleModalAlert={handleModalAlert}
                        label={"Загрузить"}
                    />
                ))}
            </Box>
        ) : <>
        <MaterialReactTable
            renderTopToolbar={({table}) => {
                return <Box sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "7px",
                    backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                }}>
                    <MRT_ToolbarAlertBanner table={table}/>
                    <Box sx={{display: "flex"}}>
                        <MRT_ToggleFiltersButton table={table}/>
                        <MRT_GlobalFilterTextField table={table}/>
                    </Box>
                </Box>
            }}
            muiTableContainerProps={{
                sx: {
                    width: '2200px',
                    maxHeight: `calc(100vh - 420px)`
                }
            }}
            muiTableBodyCellProps={{
                sx: {
                    p: '0px 0px 0px 10px',
                    m: '0px 0px 0px 0px',
                    border: "none",
                    "&:after": {
                        display: "none",
                    },
                    "& td:after": {
                        "&:hover": {
                            backgroundColor: "red"
                        }
                    },
                    "&:not(:last-of-type)": {
                        borderRight: '1px solid #EAEBEA',

                    },
                    "&:first-of-type": {
                        padding: 0,
                        width: "50px",
                        height: "36px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        color: (theme) => theme.palette.text.light,
                        "& .MuiButtonBase-root": {
                            borderRadius: "4px",
                            width: "24px",
                            height: "24px",
                            opacity: 1,
                            margin: 0,
                            padding: 0,
                            "&:hover": {
                                backgroundColor: (theme) => theme.palette.primary.stroke,
                            }
                        }
                    },
                    "& li": {
                        listStyleType: "none",
                        "& a": {
                            color: "#006CCC",
                            textDecoration: "none",
                            "&:hover": {
                                textDecoration: "underline"
                            }
                        }
                    }
                },
            }}
            muiTableHeadCellProps={{
                sx: {
                    border: '1px solid #EAEBEA',
                    backgroundColor: "#F5F6FA",
                    padding: "10px",
                    paddingBottom: " 0.2rem",
                    paddingTop: "0.2rem"
                },
            }}
            muiTableBodyRowProps={({row}) => {
                return ({
                    sx: () => ({
                        height: '36px',
                        backgroundColor: "white",
                        "&:hover& td:after": {
                            display: "none",
                        },
                        "&.MuiTableRow-root.Mui-selected": {
                            backgroundColor: (theme) => theme.palette.primary.light70,
                            "&:hover": {
                                backgroundColor: (theme) => theme.palette.primary.light50,
                            },
                        },
                        "&:hover": {
                            "& td:after": {
                                display: "none",
                            },
                            backgroundColor: (theme) => theme.palette.primary.stroke,
                        },
                        '&:nth-of-type(even)': {
                            "&.MuiTableRow-root.Mui-selected": {
                                backgroundColor: (theme) => theme.palette.primary.light,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.light50,
                                },
                            },
                            backgroundColor: (theme) => theme.palette.primary.lightGrey,
                            "&:hover": {
                                backgroundColor: (theme) => theme.palette.primary.stroke,
                            },
                        },
                    })
                })
            }}

            displayColumnDefOptions={{
                'mrt-row-actions': {
                    header: "",
                    size: 3,
                    minSize: 3,
                    grow: false,
                },
            }}
            muiSearchTextFieldProps={{
                placeholder: `Поиск`,
                sx: {
                    paddingTop: "5px",
                    paddingBottom: "0px",
                    "& .MuiCollapse-root": {
                        borderRadius: '12px',
                        height: 40, width: 290,
                        "& .MuiSvgIcon-root": {
                            color: "#737478"
                        },
                        '& .MuiOutlinedInput-input': {
                            padding: 0
                        }
                    }
                },
                variant: 'outlined',
            }}
            columns={columns}
            data={filteredData}
            rowHeight={13}
            columnSpacing={1}
            getRowId={(originalRow) => originalRow.id}
            selectionPadding={1}
            onPaginationChange={(updater) => {
                tableOptionsHandle(updater(tableOptions));
            }}
            onGlobalFilterChange={(value) => {
                handleSearchQuery(value, data, null)
            }}
            onColumnFiltersChange={(updater) => {
                handleSearchQuery(updater(columnsFilter), data, null, true)
            }}
            onShowColumnFiltersChange={handleShowColumnFilters}
            manualFiltering={true}
            state={{
                showColumnFilters: showColumnFilters,
                columnFilters: columnsFilter,
                globalFilter: globalFilter,
                showGlobalFilter: true,
                pagination: tableOptions,
            }}
            rowCount={tableOptions.totalElements}
            selectionCss={{
                backgroundColor: 'lightblue',
                borderWidth: '2px',
                borderStyle: 'solid',
                borderColor: 'blue',
                borderRadius: '4px',
            }}
            renderRowActionMenuItems={({closeMenu, row}) => menuItem.map(el => {
                return (el.type === "edit" || (el.type === "delete" && !row.original.blocked)) && <MenuItem
                    key={el.type}
                    onClick={() => {
                        el.handler(row.original)
                        closeMenu();
                    }}
                    sx={{
                        margin: "0 8px",
                        borderRadius: "4px",
                        "&:hover": {backgroundColor: (theme) => theme.palette.primary.light}
                    }}
                >
                    {el.text}
                </MenuItem>
            })
            }
            localization={MRT_Localization_RU}
            enableRowActions={true}
            enableToolbarInternalActions={false}
        />
        {modal && <ModalComposition
            title={currentEditRowData?.id ? "Изменить" : "Добавить"}
            open={modal} onClose={handleClose}
            handleSubmit={currentEditRowData?.id ? handleUpdate : handleSubmit}
            initValue={currentEditRowData}
            loading={loading}
            handleModalAlert={handleModalAlert}
            cornerTypeModuleList={cornerTypeModuleList}
            typeCompositionModuleList={typeCompositionModuleList}
        />}
        </>}
    </div>);
};

export default Composition;